import {
  Banner,
  propTypes,
  customConfigFrom,
  customCssForFrom,
} from "./sharedImports";

const NoAccessBanner = ({
  title,
  body,
  __cssFor = {},
  whiteBgColor = false,
  ctaSection = null,
}) => {
  const customConfig = customConfigFrom(whiteBgColor);
  const customCssFor = customCssForFrom(__cssFor);
  return (
    <Banner
      title={title}
      body={body}
      bannerType={Banner?.types?.custom}
      customConfig={customConfig}
      __cssFor={customCssFor}
      __renderCtaSection={ctaSection}
    />
  );
};

NoAccessBanner.propTypes = propTypes;
export default NoAccessBanner;
